angular
    .module('empower.control')
    .directive("datepickerstartdate", ['$filter', '$cacheFactory', function ($filter, $cacheFactory) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element, attrs) {
                scope.$watch(
                    "MinStartDate",
                    function () {
                        $(element).datepicker("option", "minDate", attrs.mindate);
                        //alert(attrs.mindate);                     
                    },
                    true // Object equality (not just reference).
                );
                scope.$watch(
                    "MaxStartDate",
                    function () {
                        $(element).datepicker("option", "maxDate", attrs.maxdate);
                        //alert(attrs.maxdate);                       
                    },
                    true // Object equality (not just reference).
                );

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: "dd/mm/yy",
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        onSelect: function (date) {
                            scope.date = date;

                            //var selectedDate = date;
                            var dateMin = $(this).datepicker("getDate");
                            var rMin = new Date(dateMin.getFullYear(), dateMin.getMonth(), dateMin.getDate() + 1);
                            var inputDate = new Date(dateMin);
                            // modified for leap date
                            var isLeapDate = inputDate.getMonth() == 1 && inputDate.getDate() == 29;
                            var addedDate = dateMin.getDate();
                            if (isLeapDate) {
                                addedDate -= 1;
                            }
                            var rMax = new Date(dateMin.getFullYear() + 1, dateMin.getMonth(), addedDate);
                            $('#get-a-quote-expiry-date').val($.datepicker.formatDate('dd/mm/yy', new Date(rMax)));
                            $('#get-a-quote-expiry-date').datepicker("option", "maxDate", rMax);
                            $('#get-a-quote-expiry-date').datepicker("option", "minDate", rMin);

                            scope.$apply(function () {
                                scope.setStartDate(date);
                                scope.ExpiryDate = $filter('date')(rMax, "dd/MM/yyyy");
                            });
                        },
                        onClose: function (date) {
                            if (moment(date, "DD-MM-YYYY", true) == null) {
                                return;
                            }

                            var dateParts = date.split('/');
                            if (dateParts.length != 3 || dateParts[0] == '' || dateParts[1] == '' || dateParts[2] == '') {
                                return;
                            }

                            var formattedDate = ('0' + dateParts[0]).slice(-2) + '/'
                                + ('0' + dateParts[1]).slice(-2) + '/'
                                + dateParts[2];
                            scope.date = formattedDate;

                            //var selectedDate = date;
                            var dateMin = $(this).datepicker("getDate");
                            var rMin = new Date(dateMin.getFullYear(), dateMin.getMonth(), dateMin.getDate() + 1);
                            var inputDate = new Date(dateMin);
                            // modified for leap date
                            var isLeapDate = inputDate.getMonth() == 1 && inputDate.getDate() == 29;
                            var addedDate = dateMin.getDate();
                            if (isLeapDate) {
                                addedDate -= 1;
                            }
                            var rMax = new Date(dateMin.getFullYear() + 1, dateMin.getMonth(), addedDate);
                            $('#get-a-quote-expiry-date').val($.datepicker.formatDate('dd/mm/yy', new Date(rMax)));
                            $('#get-a-quote-expiry-date').datepicker("option", "maxDate", rMax);
                            $('#get-a-quote-expiry-date').datepicker("option", "minDate", rMin);

                            scope.$apply(function () {
                                scope.setStartDate(formattedDate);
                                scope.ExpiryDate = $filter('date')(rMax, "dd/MM/yyyy");
                            });
                        }
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()
            }//link
        };//return
    }])
    .directive("expirydate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        minDate: '+1D',
                        onSelect: function (dateText) {
                            scope.$apply(function () {
                                scope.ExpiryDate = dateText;
                            });
                        },
                        onClose: function (date) {
                            if (moment(date, "DD-MM-YYYY", true) == null) {
                                return;
                            }

                            var dateParts = date.split('/');
                            if (dateParts.length != 3 || dateParts[0] == '' || dateParts[1] == '' || dateParts[2] == '') {
                                return;
                            }

                            var formattedDate = ('0' + dateParts[0]).slice(-2) + '/'
                                + ('0' + dateParts[1]).slice(-2) + '/'
                                + dateParts[2];

                            scope.$apply(function () {
                                scope.ExpiryDate = formattedDate;
                            });
                        }
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("estdate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "-70:+10",
                        maxDate: 0,
                        onSelect: function (date) {
                            scope.$apply(function () {
                                scope.NewBizInputValueStringVar.EstablishedDate = date;
                            });
                        }
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("dobdatepick", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "1900:9999",
                        maxDate: '-13Y',
                        onSelect: function (date) {
                            scope.$apply(function () {
                                scope.NewInjuryInputValueStringVar.WorkerDateOfBirth = date;
                            });

                            scope.checkPossibleBirthday();
                        }
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("vicinjurydobdatepick", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "1900:9999",
                        maxDate: '-13Y',
                        onSelect: function (date) {
                            scope.$apply(function () {
                                scope.formData.dateOfBirth = date;
                            });

                            scope.checkPossibleBirthday();
                        }
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("doblogindatepick", ['$cacheFactory', '$timeout', function ($cacheFactory, $timeout) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "1900:9999",
                        maxDate: '-13Y',
                        onSelect: function (dateText) {
                            $timeout(function () {
                                scope.credentials.dob = dateText;
                            });
                        }
                    });
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                    $(element).keydown(function (e) {
                        $timeout(function () {
                            if (e.which == 13) {
                                $(element).datepicker("hide");
                            }
                        });
                    });


                });//$(function()

            }//link
        };//return
    }])
    .directive("datepick", ['$cacheFactory', '$timeout', function ($cacheFactory, $timeout) {
        return {
            restrict: "A",
            require : "ngModel",
            scope: {
                ngModel: '='
            },
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "1900:9999",
                        maxDate:"+0Y",
                        // onSelect: function (dateText) {
                        //     $timeout(function () {
                        //         scope.ngModel = dateText;
                        //     });
                        // }
                    });
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                    $(element).keydown(function (e) {
                        $timeout(function () {
                            if (e.which == 13) {
                                $(element).datepicker("hide");
                            }
                        });
                    });


                });//$(function()

            }//link
        };//return
    }])
    .directive("fromdate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        minDate: 0,
                        maxDate: '+1Y+6M',
                        onSelect: function (dateText) {
                            // var selectedDate = dateText;
                            var dateMin = $(this).datepicker("getDate");
                            var rMin = new Date(dateMin.getFullYear(), dateMin.getMonth(), dateMin.getDate() + 1);
                            // modified for leap date
                            var isLeapDate = dateMin.getMonth() == 1 && dateMin.getDate() == 29;
                            var addedDate = dateMin.getDate();
                            if (isLeapDate) {
                                addedDate -= 1;
                            }
                            var rMax = new Date(dateMin.getFullYear() + 1, dateMin.getMonth(), addedDate);
                            $('#insurance-proposal-to-date').val($.datepicker.formatDate('dd/mm/yy', new Date(rMax)));
                            $('#insurance-proposal-to-date').datepicker("option", "maxDate", rMax);
                            $('#insurance-proposal-to-date').datepicker("option", "minDate", rMin);
                            var rMaxf = $.datepicker.formatDate('dd/mm/yy', new Date(rMax));
                            scope.$apply(function () {
                                scope.NewBizInputValueStringVar.PeriodStartDate = dateText;
                                scope.NewBizInputValueStringVar.PeriodEndDate = rMaxf;
                                scope.setStartDate(dateText);
                            });


                        }//onSelect
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("todate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        minDate: '+1D',
                        maxDate: '+1Y+6M',
                        onSelect: function (dateText) {
                            //var selectedDate = dateText;
                            //var dateMin = $(this).datepicker("getDate");
                            //var rMin = new Date(dateMin.getFullYear() - 1, dateMin.getMonth(), dateMin.getDate());
                            //$('#insurance-proposal-from-date').val($.datepicker.formatDate('dd/mm/yy', new Date(rMin)));
                            scope.$apply(function () {
                                scope.NewBizInputValueStringVar.PeriodEndDate = dateText;
                            });

                        }//onSelect
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("companystartdate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "-70:+10",
                        maxDate: 0,
                        onSelect: function (date) {
                            scope.$apply(function () {
                                scope.CompanyStartDate = date;
                            });
                        }
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("injurydate", ['$filter', '$cacheFactory', function ($filter, $cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datetimepicker({
                        dateFormat: 'dd/mm/yy',
                        timeFormat: 'hh:mm TT',
                        format: 'dd/mm/yy hh:mm TT',
                        pick12HourFormat: false,
                        hourMax: 23,
                        timepicker: true,
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "-20:+20",
                        maxDate: 0,
                        onSelect: function (dateText) {
                            var dateMin = $(this).datepicker("getDate");
                            var rMin = new Date(dateMin.getFullYear(), dateMin.getMonth(), dateMin.getDate());
                            $('#newclaim-date-employer-notified').datepicker("option", "minDate", rMin);
                            $('#newclaim-date-employer-notified').datepicker('setDate', $filter('date')(rMin, "dd/MM/yyyy"));
                            scope.$apply(function () {
                                scope.NewInjuryInputValueStringVar.InjuryDate = dateText;
                                scope.NewInjuryInputValueStringVar.DateEmployerNotified = $filter('date')(rMin, "dd/MM/yyyy");
                            });
                        }//onSelect
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })

                });//$(function()

            }//link
        };//return
    }])
    .directive("emplnotdate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "-1:+1",
                        maxDate: 0,
                        onSelect: function (dateText) {
                            //var dateMin = $(this).datepicker("getDate");
                            //$('#newclaim-date-injury').val();
                            //$('#newclaim-date-injury').datepicker("option", "maxDate", rMin);
                            scope.$apply(function () {
                                scope.NewInjuryInputValueStringVar.DateEmployerNotified = dateText;
                            });
                        }//onSelect
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("certfromdate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "-10:+10",
                        onSelect: function (dateText) {
                            //var dateMin = $(this).datepicker("getDate");
                            //$('#newclaim-date-injury').val();
                            //$('#newclaim-date-injury').datepicker("option", "maxDate", rMin);
                            scope.$apply(function () {
                                scope.NewInjuryInputValueStringVar.CertFromDate = dateText;
                            });
                        }//onSelect
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("certtodate", ['$cacheFactory', function ($cacheFactory) {
        return {
            restrict: "A",
            /*require : "ngModel",*/
            link: function (scope, element) {

                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "-10:+10",
                        onSelect: function (dateText) {
                            //var dateMin = $(this).datepicker("getDate");
                            //$('#newclaim-date-injury').val();
                            //$('#newclaim-date-injury').datepicker("option", "maxDate", rMin);
                            scope.$apply(function () {
                                scope.NewInjuryInputValueStringVar.CertToDate = dateText;
                            });
                        }//onSelect
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    .directive("commencementdate", ['$parse', '$cacheFactory', function ($parse, $cacheFactory) {
        return {
            restrict: "A",
            link: function (scope, element, attrs, controller) {
                var ngModel = $parse(attrs.ngModel);
                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    $(element).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "-70:+1",
                        maxDate: 0,
                        onSelect: function (dateText) {
                            scope.$apply(function (scope) {
                                // Change binded variable
                                ngModel.assign(scope, dateText);
                            });
                        }//onSelect
                    });//$(element).datepicker({
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    $(element).focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            $(element).datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    // For other kinds of date picker please add this directive to tag
    .directive("datepicker", ['$parse', '$cacheFactory', function ($parse, $cacheFactory) {
        return {
            restrict: "A",
            link: function (scope, element, attrs, controller) {
                var ngModel = $parse(attrs.ngModel);
                $(function () {
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                    // Initial state 
                    var cache = $cacheFactory.get('location-changed');
                    cache.put('location-changed', false);

                    element.datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        maxDate: 0,
                        onSelect: function (dateText, inst) {
                            scope.$apply(function (scope) {
                                // Change binded variable
                                ngModel.assign(scope, dateText);
                            });
                        }
                    });
                    // RUN-3953: [Add new business]Date picker table does not disappear when click button 'Back' to EMpower Homepage.
                   element.focusout(function () {
                        var isViewChanged = cache.get('location-changed');
                        if (isViewChanged == true) {
                            element.datepicker('hide');
                            cache.put('location-changed', false);
                        }
                    })
                });//$(function()

            }//link
        };//return
    }])
    /*.directive('datepicker', function ($parse) {
        return function (scope, element, attrs, controller) {
            var ngModel = $parse(attrs.ngModel);
            $(function () {
                element.datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    maxDate: 0,
                    onSelect: function (dateText, inst) {
                        scope.$apply(function (scope) {
                            // Change binded variable
                            ngModel.assign(scope, dateText);
                        });
                    }
                });
                element.focusout(function () {
                    element.datepicker('hide');
                })
            });
        }
    });*/